import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import NotificationService from "../../services/NotificationService";
import Swal from "sweetalert2";

class NotificationPrefers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      business:[],
      formData : {
        // Kanal bayrakları
        allow_push: 1,
        allow_email: 1,
        allow_sms: 0,
        // Bildirimler varsayılan aktif
        is_notification_active: 1,
      },
      loading:false,
      isLoad:true,
      webPushPermission: 'default', // 'default', 'granted', 'denied', 'not-supported'
      webPushEnabled: false,
      webPushLoading: false,
    }
  }
  componentDidMount() {
    this.getBusinessInfo();
    this.checkWebPushStatus();
  }

  /**
   * Check web push notification status
   */
  checkWebPushStatus = async () => {
    try {
      const permissionStatus = NotificationService.getPermissionStatus();
      const isEnabled = await NotificationService.isPushEnabled();
      
      this.setState({
        webPushPermission: permissionStatus,
        webPushEnabled: isEnabled
      });
    } catch (error) {
      console.error('Error checking web push status:', error);
      this.setState({
        webPushPermission: 'not-supported',
        webPushEnabled: false
      });
    }
  }

  /**
   * Request web push notification permission
   */
  handleRequestWebPushPermission = async () => {
    this.setState({ webPushLoading: true });
    
    try {
      const hasPermission = await NotificationService.requestPermission();
      
      if (hasPermission) {
        // Initialize push notifications
        const initialized = await NotificationService.initialize();
        
        if (initialized) {
          await this.checkWebPushStatus();
          Swal.fire({
            title: 'Başarılı',
            text: 'Web push bildirimleri aktif edildi!',
            icon: 'success',
            confirmButtonText: 'Tamam'
          });
        } else {
          Swal.fire({
            title: 'Hata',
            text: 'Bildirimler başlatılamadı. Lütfen tekrar deneyin.',
            icon: 'error',
            confirmButtonText: 'Tamam'
          });
        }
      } else {
        Swal.fire({
          title: 'İzin Reddedildi',
          text: 'Bildirim izni verilmedi. Tarayıcı ayarlarından izin verebilirsiniz.',
          icon: 'warning',
          confirmButtonText: 'Tamam'
        });
      }
    } catch (error) {
      console.error('Error requesting web push permission:', error);
      Swal.fire({
        title: 'Hata',
        text: 'Bildirim izni istenirken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    } finally {
      this.setState({ webPushLoading: false });
    }
  }

  /**
   * Disable web push notifications
   */
  handleDisableWebPush = async () => {
    try {
      await NotificationService.unsubscribe();
      await this.checkWebPushStatus();
      Swal.fire({
        title: 'Başarılı',
        text: 'Web push bildirimleri devre dışı bırakıldı.',
        icon: 'success',
        confirmButtonText: 'Tamam'
      });
    } catch (error) {
      console.error('Error disabling web push:', error);
      Swal.fire({
        title: 'Hata',
        text: 'Bildirimler devre dışı bırakılırken bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
    }
  }

  getBusinessInfo = async () => {

    try {
      const response = await apiCall('business/settings/notification-prefers/info', 'get', null);
      const updatedData = { ...this.state.formData };
    const booleanKeys = ['allow_push', 'allow_email', 'allow_sms', 'is_notification_active'];
    const defaults = { allow_push: 1, allow_email: 1, allow_sms: 0, is_notification_active: 1 };

      Object.keys(updatedData).forEach(key => {
        const val = response[key];
        if (booleanKeys.includes(key)) {
          if (typeof val === 'number') {
            updatedData[key] = val;
          } else if (typeof val === 'boolean') {
            updatedData[key] = val ? 1 : 0;
          } else {
            updatedData[key] = defaults[key];
          }
        } else {
          updatedData[key] = val === undefined || val === null ? "" : val;
        }
      });

      this.setState({ formData: updatedData, isLoad: false });

    } catch (e) {
      this.setState({ isLoad: false });
    }
  }

  handleChange = (e) => {
    const { id,name, value } = e.target;
    const key = name || id;
    // is_notification_active UI'da kilitli, yine de backend'e gönderilebilir
    if (key === "is_notification_active" || key === "allow_push" || key === "allow_email" || key === "allow_sms"){
      this.setState(prevState =>({
        formData: {
          ...prevState.formData,
          [key]:value === '0' ? 0 : 1
        }

      }))
    }else {
      this.setState(prevState =>({
        formData: {
          ...prevState.formData,
          [key]:value
        }

      }))
    }

  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({loading:true});
    const {formData} = this.state;
    const businessFormData = new FormData();
    Object.keys(formData).forEach(key => {
      businessFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/settings/notification-prefers/update','post',businessFormData);
      this.setState({loading:false});
      mainHelper.toastMessage(response.status,response.message);
    }catch (e) {
      this.setState({loading:false});
    }

  }
  render() {
    const {formData,loading} = this.state;
    const {userPermissions} = this.props;
    const userHasNotificationPreferPermission = userPermissions.includes('update notifications');
    const switchStyle = { marginBottom: 0 };
    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
              document.body.classList.remove("offcanvas-active");
            }}
        >
          <div>
            <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
              <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="m-t-30">
                  <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
                </div>
                <p>Yükleniyor</p>
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
              </div>
            </div>
            <div className="container-fluid">
              <PageHeader
                  HeaderText="Bildirim Tercihleri"
                  Breadcrumb={[
                    {name: "Ayarlar", navigate: ""},
                    {name: "Bildirim Tercihleri", navigate: ""},
                  ]}
              />
              <div className="row clearfix">
                <div className="col-lg-12">
                  <div className="card">
                    <form onSubmit={this.handleSubmit}>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-6">
                            <div className="form-group">
                              <label htmlFor="status" className="font-weight-bold text-cyan">
                                Bildirimler
                              </label>
                              <small className="text-muted d-block mb-2">
                                Müşteri bilgilendirmesi için bildirimler varsayılan olarak açıktır ve kapatılamaz.
                              </small>
                              <div className="custom-control custom-switch">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="is_notification_active"
                                      name="is_notification_active"
                                    checked={true}
                                    disabled
                                />
                                <label className="custom-control-label" htmlFor="is_notification_active"></label>
                              </div>
                            </div>
                            <div className="form-group">
                              <label className="font-weight-bold text-cyan">
                                Kanal Tercihleri
                              </label>
                              <small className="text-muted d-block mb-3">
                                Öncelik: Uygulama bildirimi (push). Uygulama bildirimi yoksa seçili kanaldan (e-posta /
                                SMS) gönderilir.
                              </small>
                              <div className="form-group d-flex align-items-center justify-content-between">
                              <div>
                                  <div className="font-weight-bold text-cyan">Uygulama Bildirimi (Push)</div>
                                  <small className="text-muted">Varsayılan önerilen kanal</small>
                                </div>
                                <div className="custom-control custom-switch" style={switchStyle}>
                                  <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="allow_push"
                                      checked={formData.allow_push === 1}
                                      onChange={(e) => this.handleChange({
                                        target: {
                                          name: 'allow_push',
                                          value: e.target.checked ? '1' : '0'
                                        }
                                      })}
                                  />
                                  <label className="custom-control-label" htmlFor="allow_push"></label>
                                </div>
                              </div>

                              <div className="form-group d-flex align-items-center justify-content-between">
                                <div>
                                  <div className="font-weight-bold text-cyan">E-posta Bildirimleri</div>
                                  <small className="text-muted">Önemli bildirimler için önerilir</small>
                            </div>
                                <div className="custom-control custom-switch" style={switchStyle}>
                                  <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="allow_email"
                                      checked={formData.allow_email === 1}
                                      onChange={(e) => this.handleChange({
                                        target: {
                                          name: 'allow_email',
                                          value: e.target.checked ? '1' : '0'
                                        }
                                      })}
                                  />
                                  <label className="custom-control-label" htmlFor="allow_email"></label>
                              </div>
                            </div>

                              <div className="form-group d-flex align-items-center justify-content-between">
                              <div>
                                  <div className="font-weight-bold text-cyan">SMS Bildirimleri</div>
                                  <small className="text-muted">Telefon numarası gerekir.</small>
                              </div>
                                <div className="custom-control custom-switch" style={switchStyle}>
                                  <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="allow_sms"
                                      checked={formData.allow_sms === 1}
                                      onChange={(e) => this.handleChange({
                                        target: {
                                          name: 'allow_sms',
                                          value: e.target.checked ? '1' : '0'
                                        }
                                      })}
                                  />
                                  <label className="custom-control-label" htmlFor="allow_sms"></label>
                            </div>
                              </div>
                              <div className="form-group"
                                   style={{marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e0e0e0'}}>
                              <label className="font-weight-bold text-cyan">
                                Web Push Bildirimleri
                                  <small style={{display: 'block', marginTop: '5px', fontWeight: 'normal'}}>
                                    Tarayıcı bildirimleri almak için izin verin. Uygulama kapalıyken bile bildirim
                                    alabilirsiniz.
                                </small>
                              </label>
                              
                              {this.state.webPushPermission === 'not-supported' && (
                                    <div className="alert alert-warning" style={{marginTop: '10px'}}>
                                      <i className="fa fa-exclamation-triangle"></i> Bu tarayıcı web push bildirimlerini
                                      desteklemiyor.
                                </div>
                              )}

                              {this.state.webPushPermission === 'denied' && (
                                      <div className="alert alert-danger" style={{marginTop: '10px'}}>
                                        <i className="fa fa-ban"></i> Bildirim izni reddedildi. Tarayıcı ayarlarından izin
                                        verebilirsiniz.
                                </div>
                              )}

                              {this.state.webPushPermission === 'granted' && this.state.webPushEnabled && (
                                    <div className="alert alert-success" style={{marginTop: '10px'}}>
                                  <i className="fa fa-check-circle"></i> Web push bildirimleri aktif.
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger ml-2"
                                    onClick={this.handleDisableWebPush}
                                  >
                                    Devre Dışı Bırak
                                  </button>
                                </div>
                              )}

                                  {(this.state.webPushPermission === 'default'
                                    || this.state.webPushPermission === 'denied'
                                    || (this.state.webPushPermission === 'granted' && !this.state.webPushEnabled)) && (
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={this.handleRequestWebPushPermission}
                                  disabled={this.state.webPushLoading}
                                        style={{marginTop: '10px'}}
                                >
                                  {this.state.webPushLoading ? (
                                    <>
                                            <ReactLoading type="spin" width={'16px'} height={'16px'} color="#268bd2"
                                                          style={{display: 'inline-block', marginRight: '8px'}}/>
                                      İşleniyor...
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa fa-bell"></i> Bildirim İzni Ver
                                    </>
                                  )}
                                </button>
                              )}
                            </div>

                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                                    <button className="btn btn-outline-primary btn-block"
                                            disabled={true}
                                            style={{textAlign: "-webkit-center"}}>
                                      Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                      height={'24px'}
                                                                      color="#268bd2"></ReactLoading>
                                    </button>
                                ) :
                                <button disabled={!userHasNotificationPreferPermission}
                                        className="btn btn-outline-primary btn-block"
                                        type="submit">
                                  Güncelle
                                </button>}

                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(NotificationPrefers)));
